import {
    USUARI_INICIALITZAR,
    USUARI_INTRODUCCIO_OBTENIR_DADES_EN_CURS,
    USUARI_INTRODUCCIO_OBTENIR_DADES_FINALITZADA
} from '../../../actions/actionTypes';

const ESTAT_INICIAL = false;

const peticioObtenirDadesEnCurs = (state = ESTAT_INICIAL, action) => {
    switch (action.type) {
        case USUARI_INICIALITZAR:
            return ESTAT_INICIAL;

        case USUARI_INTRODUCCIO_OBTENIR_DADES_EN_CURS:
            return true;

        case USUARI_INTRODUCCIO_OBTENIR_DADES_FINALITZADA:
            return false;

        default:
            return state;
    }
};

export default peticioObtenirDadesEnCurs;



// WEBPACK FOOTER //
// ./src/reducers/usuari/formulari/peticioObtenirDadesEnCurs.js